import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FaHamburger } from "react-icons/fa";
import { BsCheckCircleFill } from "react-icons/bs";
import useGeneralStore from "../../../../store/generalStore";
import useAuthStore from "../../../../store/authStore";
import { agentLogout } from "../../../../API/commonApis";
import { changeCall_AuditStatus } from "../../../../API/agentApis";
import Logo from "../../../../Static/RawImages/logo.png";
import VideoComponent from "./VideoComponent";
import "../../Introduction.css";

const BaseStepComponent = ({ 
  stepNumber,
  title,
  videoSrc,
  directLink,
  nextStep,
}) => {
  // States
  const [videoWatched, setVideoWatched] = useState(false);
  
  // Store and history
  const isSidebarOpen = useGeneralStore((state) => state.is_sidebar_open);
  const toggleSidebar = useGeneralStore((state) => state.toggle_sidebar);
  const removeUser = useAuthStore((state) => state.removeUser);
  const setAuditCallStepCount = useGeneralStore((state) => state.setAuditCallStepCount);
  const history = useHistory();

  // Steps data for sidebar
  const steps = [
    { id: 1, name: "Tele-Collection Process" },
    { id: 2, name: "Agent Panel" },
    { id: 3, name: "Call Script" },
    { id: 4, name: "Live Call" },
    { id: 5, name: "Live Calls" },
  ];

  // Handle next step
  const handleNextStep = async () => {
    try {
      // Update the step count in the API and store
      const data = await changeCall_AuditStatus({ type: "step_count", step_count: nextStep });
      if (data) {
        setAuditCallStepCount(nextStep);
        
        // If we've completed all intro steps, move to the intro thank you page
        if (stepNumber === 5) {
          history.push("/agent/introduction/completion");
        } else {
          // Otherwise, just update the step counter, the router will handle showing the next step
          history.push("/agent/introduction");
        }
      }
    } catch (error) {
      console.error('Failed to update step count:', error);
    }
  };

  // Go to previous step
  const handlePrevStep = async () => {
    if (stepNumber > 1) {
      const prevStep = stepNumber - 1;
      try {
        const data = await changeCall_AuditStatus({ type: "step_count", step_count: prevStep });
        if (data) {
          setAuditCallStepCount(prevStep);
          history.push("/agent/introduction");
        }
      } catch (error) {
        console.error('Failed to update step count:', error);
      }
    }
  };

  // Logout function
  const handleLogout = async () => {
    try {
      await agentLogout();
      if (removeUser) removeUser();
      history.push("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="introduction-container">
      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <div className="logo">
            <a href="/">
              <img src={Logo || "/placeholder.svg"} alt="logo" />
            </a>
            <div className="admin-tag mt-1">Agent</div>
          </div>
          <div className="menu-toggle" onClick={toggleSidebar}>
            <FaHamburger />
          </div>
        </div>

        <div className="sidebar-menu">
          <ul className="nav flex-column">
            <li className="nav-item">
              <a
                className="nav-link d-flex align-items-start justify-content-start w-100 gap-1"
                href="#"
                style={{ fontWeight: "bold", color: "#000000" }}
              >
                <div className="m-icon" style={{ minWidth: "20px", height: "23px" }}>
                  <svg width="20" height="17" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 0H1.5V22.75H28.75V24.25H0V0ZM28.35 2.95L18.8857 15.569L11.3801 9.56454L5.34577 17.4556L4.15423 16.5444L11.1199 7.43546L18.6143 13.431L27.15 2.05L28.35 2.95Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <span
                  style={{
                    lineHeight: "1.3rem",
                    whiteSpace: "normal",
                    display: isSidebarOpen ? "inline-block" : "none",
                  }}
                >
                  Video Process Training
                </span>
              </a>
            </li>
          </ul>

          <div className="stepper-container">
            <div className="stepper">
              {steps.map((step, index) => {
                let status = "pending";
                if (step.id < stepNumber) {
                  status = "completed";
                } else if (step.id === stepNumber) {
                  status = "in-progress";
                }

                return (
                  <div key={step.id} className={`step-item ${status}`}>
                    <div className="step-indicator">
                      {status === "completed" ? (
                        <BsCheckCircleFill className="check-icon" />
                      ) : (
                        <div className={`circle ${status === "in-progress" ? "active" : ""}`}>
                          {status === "in-progress" ? <div className="inner-circle" /> : null}
                        </div>
                      )}
                      {index < steps.length - 1 ? (
                        <div
                          className="line"
                          style={{
                            background:
                              status === "completed"
                                ? "#28a745"
                                : status === "in-progress"
                                  ? "linear-gradient(to bottom, #28a745 50%, #ccc 50%)"
                                  : "#ccc",
                          }}
                        />
                      ) : null}
                    </div>
                    <div className="step-content" style={{ display: isSidebarOpen ? "block" : "none" }}>
                      <div className="step-label">
                        STEP {step.id}
                        <span className={`status-label ${status}`}>
                          {status === "completed" ? "Completed" : status === "in-progress" ? "In Process" : "Pending"}
                        </span>
                      </div>
                      <div className="step-title">{step.name}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="p-7 d-flex justify-content-center align-items-center">
          <Button className="" onClick={handleLogout}>
            Logout User
          </Button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="content-body">
          <h2 className="video-title">
            Part {stepNumber} - {title}
          </h2>
          <div className="video-container">
            <VideoComponent 
              videoSrc={videoSrc}
              directLink={directLink}
              onVideoWatched={setVideoWatched}
            />
          </div>

          <div className="navigation-buttons d-flex justify-content-between align-items-center">
            <Button variant="secondary" onClick={handlePrevStep} disabled={stepNumber === 1}>
              Previous
            </Button>
            <Button variant="primary" onClick={handleNextStep} disabled={!videoWatched}>
              {stepNumber === 5 ? "Finish" : "Next"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseStepComponent; 